import { FC } from "react";
import { Outlet } from "react-router-dom";

import { SidebarMenu } from "@components/SidebarMenu";
import { UserDropdown } from "@components/UserDropdown";

import { Content, Layout } from "./styles";
const { Sider, Header } = Layout;

export interface IPageLayoutProps {
  showSider?: boolean;
  showHeader?: boolean;
}

export const PageLayout: FC<IPageLayoutProps> = ({ showSider, showHeader }) => {
  return (
    <Layout>
      {showSider && (
        <Sider width={260} breakpoint="sm" collapsedWidth="60" theme="light">
          <SidebarMenu />
        </Sider>
      )}

      <Content>
        {showHeader && (
          <Header style={{ height: 104, padding: "15px 0" }}>
            <UserDropdown />
          </Header>
        )}

        <Outlet />
      </Content>
    </Layout>
  );
};
